import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import LinkToQVView from 'Common/components/LinkToQVView/LinkToQVView';
import useRouter from 'Router/index';
export const PLACEHOLDER_LABEL_TEXT = 'Variants N/A';
export const QVTableCellLink = memo(function QVTableCellLink({ ancestry, collapsingModelId, geneNameFromData, traitsType, phenotypeId, category, label, referrerData, pvalue, cases, }) {
    /** @todo Change approach of getting data from router */
    const { getParams } = useRouter();
    const { datasetVersionId, geneName } = getParams();
    const geneProp = geneNameFromData !== null && geneNameFromData !== void 0 ? geneNameFromData : geneName; // Because rowData doesn't have gene on GeneView
    return (_jsx(LinkToQVView, { ancestry: ancestry, datasetVersionId: datasetVersionId, geneId: geneProp, phenotypeId: phenotypeId, phenotypicCategoryId: category, collapsingModelId: collapsingModelId, traitsType: traitsType, referrerData: referrerData, label: label, title: label, pvalue: pvalue, cases: cases, placeholderLabel: PLACEHOLDER_LABEL_TEXT }, void 0));
});
